import ReactPaginate from "react-paginate";
import CommonButton from "../../components/ui/CommonButton/CommonButton";
import CommonCard from "../../components/ui/CommonCard/CommonCard";
import classes from "./Referrals.module.css";
import { useEffect, useState } from "react";
import { MdInfoOutline } from "react-icons/md";
import { IoClose, IoCloseCircleOutline } from "react-icons/io5";
import BankIcon from "../../icons/BankIcon";
import InputField from "../../components/ui/InputField/InputField";
import { useTheme } from "../../context/ThemeContext";
import useWindowDimensions from "../../hooks/getWindowDimensions";
import { RxCaretDown } from "react-icons/rx";
import VerticalDotsIcon from "../../icons/VerticalDotsIcon";
import ActionCard from "../../components/ActionCard/ActionCard";
import AlertDialog from "../../components/ui/AlertDialog/AlertDialog";
import OutlinedButton from "../../components/ui/OutlinedButton/OutlinedButton";
import { env } from "../../constants/env";
import { formatDate } from "../../utilities/functions";
import axios from "axios";
import { toast } from "react-toastify";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import Table from "../../components/Table/Table";
import { use } from "react";

const token = localStorage.getItem("token");


const referrals = [
  {
    referrerEmail: "username@email.com",
    referralEmail: "username@email.com",
    status: "Paid",
    method: "USDT (TRC)",
    commissionEarned: "$100.00"
  },
  {
    referrerEmail: "username@email.com",
    referralEmail: "username@email.com",
    status: "Free",
    method: "USDT (TRC)",
    commissionEarned: "$100.00"
  },
  {
    referrerEmail: "username@email.com",
    referralEmail: "username@email.com",
    status: "Paid",
    method: "USDT (TRC)",
    commissionEarned: "$100.00"
  },
  {
    referrerEmail: "username@email.com",
    referralEmail: "username@email.com",
    status: "Paid",
    method: "USDT (TRC)",
    commissionEarned: "$100.00"
  },
  {
    referrerEmail: "username@email.com",
    referralEmail: "username@email.com",
    status: "Paid",
    method: "USDT (TRC)",
    commissionEarned: "$100.00"
  },
  {
    referrerEmail: "username@email.com",
    referralEmail: "username@email.com",
    status: "Paid",
    method: "USDT (TRC)",
    commissionEarned: "$100.00"
  },
  {
    referrerEmail: "username@email.com",
    referralEmail: "username@email.com",
    status: "Paid",
    method: "USDT (TRC)",
    commissionEarned: "$100.00"
  },
  {
    referrerEmail: "username@email.com",
    referralEmail: "username@email.com",
    status: "Paid",
    method: "USDT (TRC)",
    commissionEarned: "$100.00"
  },
  
]


const Referrals = () => {

  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState("");
  const { darkMode } = useTheme();
  const [showDialog, setShowDialog] = useState();
  const [dialogContent, setDialogContent] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const [showTableDialog, setShowTableDialog] = useState(false);

  const [commissions, setCommissions] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchCommissions(currentPage);
  }, [currentPage]);

  const fetchCommissions = async (page) => {
    try {
      const response = await axios.get(`${env.apiUrl}/api/commissions/requests`, {
        params: { page, limit: 10 },headers: {
          Authorization: `Bearer ${token}`, // Add token to Authorization header
        },
      });

      setCommissions(response.data.commissions);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching commissions:", error);
    }
  };



    // Define the columns to be displayed
    const columns = [
      { key: "referrerEmail", label: "Referrer email" },
      { key: "address", label: "Address" },
      { key: "status", label: "Status" },
      { key: "method", label: "Method" },
      { key: "commissionEarned", label: "Commission earned" },
    ];


  // if (loading) return <div>Loading...</div>;
  // if (error) return <div>{error}</div>;

  return (
    <div className={classes.wrapper}>
      {/* <div className="d-flex align-items-center justify-content-center">
        <InputField
          className={classes.searchInput}
          search={true}
          placeholder="Search users"
          onChange={handleSearch}
        />
      </div> */}
      <div className="mt-3">
       <h3>Referrals</h3>
       </div>
      <CommonCard className={`${classes.tableCard} mt-4`}>

        <Table data={commissions} dataType={"Referrals"} userInfo={() => {setShowDialog(true); setDialogContent("info")}} editUser={() => {setShowDialog(true); setDialogContent('edit')}} suspendUser={() => {setShowDialog(true); setDialogContent("suspend")}} deleteUser={() => {setShowDialog(true); setDialogContent("delete")}} columns={columns} clickedIndex={(index) => setSelectedUser(index)} showDialog={showTableDialog} setShowDialog={(value) => setShowTableDialog(value)}/>
       
        {/* <AlertDialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        centerCard={true}
        titleText={dialogContent === "edit" ? "Edit user" : "Info"}
        showCloseIcon={dialogContent !== "edit"}
        style={{left: `calc(50vw - ${dialogContent === "edit" ? "130px" : "225px"})`}}
        showToSection={((dialogContent !== "delete") && (dialogContent !== "suspend"))}
      >
        {dialogContent === "info" ?
       
        
          <>
            <div className={`row ${classes.contentSection}`}>
            {withDrawalrequest.map((item, i) => (<div className="col-6 mb-3" key={i}>
                <div className={classes.titleText}>{item.title}</div>
                <div className={`${classes.valueText} ${item.value === "Approved" ? classes.successText : item.value === "Declined" && classes.dangerText}`}>{item.value}</div>
              </div>))}
          </div>
          </> :  <div className={classes.declinedContainer}>

          {dialogContent === "edit" ? <div className="d-flex flex-column gap-3">
          <input type="text" placeholder="Jane Doe" value={username} onChange={(e) => setUsername(e.target.value)}/>
          <input type="text" placeholder="jdoe@gmail.com" value={email} onChange={(e) => setEmail(e.target.value)}/>
          </div> : <p>{`Are you sure you want to ${dialogContent === "delete" ? "remove" : "suspend"} this user? This action cannot be undone`}</p>}
          <div className="row mt-3">
            <div className="col-6">
            <button className={classes.cancelButton} onClick={() => setShowDialog(false)}>Cancel</button>
            </div>
            <div className="col-6">
            <button className={`${classes.declineButton} ${dialogContent !== "edit" && classes.deleteButton}`} onClick={() => dialogContent === "delete" ? deleteUser(userInfo.id) : dialogContent === "suspend" ? suspendUser(userInfo.id) : dialogContent === "edit" && updateUser(userInfo.id)  } >{dialogContent === "delete" ? "Remove user" : dialogContent === "suspend" ? "Suspend user" : "Save changes"}</button>
            </div>
          </div>
        </div>}
          
       
      </AlertDialog> */}
       <ReactPaginate
          previousLabel={<FaChevronLeft />} // React Icon for left arrow
          nextLabel={<FaChevronRight />}   // React Icon for right arrow
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={1}
          // onPageChange={handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          previousLinkClassName={`page-link ${
            currentPage === 0 ? "disabled" : ""
          }`}
          nextLinkClassName={`page-link ${
            currentPage === totalPages - 1 ? "disabled" : ""
          }`}
          activeClassName={"active"}
        /> 
      </CommonCard>
    </div>
  );
};

export default Referrals;
